import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import WIPHeader from "../components/WIP-Herder";

function StockDetails() {
  const { fileName } = useParams(); // Get file name from URL
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate(); // For back button

  
      // ** Check Session & Redirect if Not Authenticated **
      const checkAuth = useCallback(() => {
        const authData = sessionStorage.getItem("auth");
        if (!authData) {
          window.location.href = "/wip-login"; // Redirect to login
          return;
        }
    
        const { loggedIn, expiryTime } = JSON.parse(authData);
        if (!loggedIn || Date.now() > expiryTime) {
          sessionStorage.removeItem("auth"); // Clear session
          window.location.href = "/wip-login"; // Redirect to login
        }
      }, []);

  const fetchFileData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/api/get-RM-data/${encodeURIComponent(fileName)}`);
      setFileData(response.data);
    } catch (error) {
      console.error("Error fetching stock file data:", error);
    } finally {
      setLoading(false);
    }
  }, [fileName]); 

  useEffect(() => {
    fetchFileData();
  }, [fetchFileData]);

      // ** Run Session Check & Fetsch Data **
        useEffect(() => {
          checkAuth(); // Initial session check
          fetchFileData(); // Fetch data
      
          const interval = setInterval(checkAuth, 1000); // Check session every second
          return () => clearInterval(interval); // Cleanup on component unmount
        }, [checkAuth, fetchFileData]);

  const columns = [
    { name: "Item Discription", selector: (row) => (
      <span
      data-toggle="tooltip"
      data-placement="top"
      title={row.Iteam}
      >
        {row.Iteam}
      </span>
    ), sortable: true },
    { name: "Item Name", selector: (row) => row.KD_CODE || "N/A", sortable: true },      
    { name: "RM Item Code", selector: (row) => row.Rm_Item_Code || "N/A", sortable: true },
    { name: "Unit", selector: (row) => row.Unit, sortable: true },
    { 
      name: "Plan Qty", 
      selector: (row) => row.Plan_Qty, 
      sortable: true,
      cell: (row) => {
        const hasPO = row.PO_Number && row.PO_Number.trim() !== "N/A"; // Check if PO number exists
        return (
          <span style={{ 
            color: row.Is_Highlighted === 1 && !hasPO ? "red" : "black", // Only red if no PO
            fontWeight: row.Is_Highlighted === 1 ? "bold" : "normal" 
          }}>
            {row.Plan_Qty || "N/A"}
          </span>
        );
      }
    },
    { name: "Stock In Hand", selector: (row) => row["STOCK IN HAND" ] || 0, sortable: true }, 
    { name: "PO Number", selector: (row) => row.PO_Number || "N/A", sortable: true },
  
    // { name: "Uploaded Date", selector: (row) => row.Uploaded_Date, sortable: true },
  ];

    // ** Conditional Row Styling (Make whole row red if `Is_Highlighted = 1`) **
    const conditionalRowStyles = [
      {
        when: (row) => row.Is_Highlighted === 1 && !row.PO_Number,  // 🔴 Red if PO Number is NULL
        style: {
          backgroundColor: "#ffcccc", // Light red background
          color: "black",
          fontWeight: "bold",
        },
      },
      {
        when: (row) => row.Is_Highlighted === 1 && row.PO_Number,  // ✅ Green if PO Number exists
        style: {
          backgroundColor: "#ccffcc", // Light green background
          color: "black",
          fontWeight: "bold",
        },
      },
    ];

    
  return (
    <div className="d-flex dashboard">
      <div className="flex-grow-1">
        <WIPHeader />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <h3 className="mb-4">Stock Details for File: {decodeURIComponent(fileName)}</h3>

          <button 
            onClick={() => navigate(-1)}
            className="btn btn-secondary mb-3"
          >
            ← Back to Stock View
          </button>

          {loading ? (
            <div className="text-center">
              <span className="spinner-border text-primary"></span> Loading data...
            </div>
          ) : (
            <DataTable 
              columns={columns} 
              data={fileData} 
              pagination 
              highlightOnHover 
              conditionalRowStyles={conditionalRowStyles} 
            />
          )}
        </main>
      </div>
    </div>
  );
}

export default StockDetails;
